const dogDB = [
  {
    name: "요크셰테리어",
    englishName: "Yorkshire Terrier",
    description:
      "기품 있는 외모가 돋보이는 당신은 요크셰테리어를 닮았군요! 요크셰테리어는 과거 유럽 상류계급에서 주로 키우던 견종으로, 주인에게는 애교 많고 충성심이 강하지만 낯선 사람에게는 한없이 강한 경계심을 보인답니다. 소형견이지만 사냥개이기 때문에 겁이 없고, 활동적인 성격을 갖고 있다는 특징이 있어요!",
    imageUrl: "요크셰테리어.jpg",
  },
  {
    name: "시츄",
    englishName: "Shih Tzu",
    description:
      "크고 동그란 눈을 가진 당신은 귀여운 시츄를 닮았군요! 중국 궁중견으로도 유명한 시츄는 사교적이고 순한 성격을 가져 많은 이들의 사랑을 받고 있죠. 간혹 식탐이 강하고 쉽게 싫증을 잘 내 우리를 당황시키기도 하지만, 순둥순둥한 얼굴을 보고 있으면 예뻐할 수 밖에 없는 작고 소중한 우리의 시chu~😘",
    imageUrl: "시츄.jpg",
  },
  {
    name: "말티즈",
    englishName: "Maltese",
    description:
      "하얗고 검은 눈을 가진 당신은 말티즈를 닮았군요! 오래된 역사를 자랑하는 말티즈는 과거 영국 왕실과 귀족들에게 많은 사랑을 받으며 자라와 애교가 많고 영특한 특징이 있어요. 처음엔 낯을 가리지만 경계심이 풀리면 특유의 활발한 성격으로 누구와도 잘 어울리는 전형적인 ENFP 성격이랍니다🐱‍🏍",
    imageUrl: "말티즈.jpg",
  },
  {
    name: "비숑",
    englishName: "Bichon Frise",
    description:
      "풍성한 머리를 가진 당신은 비숑 프리제를 닮았군요! ‘곱슬거리는 털’이라는 뜻을 가진 비숑은 낯가림이 없어 주인 뿐만 아니라 타 견종 또는 사람과도 쉽게 친해지는 특징이 있어요. 또한 비숑은 상당한 활동량을 자랑하며, 눈치가 빠르고 지능이 높다는 특징도 있답니다. 어울려 노는 것 뿐만 아니라 혼자 노는 것도 좋아하는 비숑은 인싸와 아싸의 기질을 모두 갖고 있는 매력덩어리😎",
    imageUrl: "비숑.jpg",
  },
  {
    name: "웰시코기",
    englishName: "Welsh Corgi",
    description:
      "통통한 매력을 가진 당신은 웰시코기를 닮았네요! 사람으로 치면 유능한 워커홀릭에 속하는 웰시코기는 과거 영국에서는 웰시코기의 다리가 짧아 가축의 다리 사이로 지나다닐 수 있고 머리가 매우 영리하여 가축을 모는 일을 했다고 해요! 지금은 귀여운 외모는 물론 애교 많고 지능도 높아 많은 이들의 사랑을 받고 있는 견종이에요🐶",
    imageUrl: "웰시코기.jpg",
  },
  {
    name: "포메라니안",
    englishName: "Pomeranian",
    description:
      "작은 고추가 맵다! 귀엽고 사랑스러운 외모를 가진 당신은 포메라니안을 닮았군요! ‘난쟁이 스피츠’라고도 불리는 포메라니안은 썰매를 끄는 대형견에 속했지만, 실내견으로 개량되어 지금의 귀여운 모습을 갖게 되었답니다. 소형견 중에서도 유독 영특한 우리의 포메는 예민하고 앙칼진 성격 덕에 자기보다 큰 견종들에게 덤벼드는 무모함을 갖고 있어요! 혹시 당신도 강강약강인 성격을…?",
    imageUrl: "포메라니안.jpg",
  },
  {
    name: "푸들",
    englishName: "Poodle",
    description:
      "오똑한 코와 달걀형 얼굴의 소유자인 당신은 푸들을 닮았군요! 현재 반려견으로 많은 사랑을 받고 푸들은 물에 빠진 오리 등을 건져내는 조렵견 역할을 하던 견종이었다고 해요! 애교 많고 순한 성격으로 다른 동물들과 잘 어울려 지낼 뿐 아니라, 강아지 지능 상위 2위에 빛나는 다채로운 매력의 소유견이랍니다😏",
    imageUrl: "푸들.jpg",
  },
  {
    name: "퍼그",
    englishName: "Pug",
    description:
      "한번보면 잊을 수 없는 얼굴을 가진 당신은 퍼그를 닮았네요! 16세기쯤 실크로드로 전세계를 휘어잡고 있던 중국인들이 영국으로 퍼그를 데려 가면서 유럽에 알려지게 되었습니다. 퍼그는 느긋하고 순한 성격을 가지고 있지만 자기만의 고집이 있습니다. 또, 식탐이 상상을 초월할 정도로 강해서 자칫하면 쉽게 비만이 될 수 있어요.🙄 ",
    imageUrl: "퍼그.jpg",
  },
  {
    name: "코카스파니엘",
    englishName: "Cocker Spaniel",
    description:
      "큰 귀와 잘생긴 외모의 소유자인 당신은 코카스파니엘을 닮았군요! 과거 사낭견이었던 코카스파니엘은 활기차고 애정이 넘치는 견종이지만, 우리나라에서는 유독 3대 악마견으로도 불리는 견종이기도 합니다. 왕성한 체력과 활동량에 비해 좁은 실내에서 자라게 되면 스트레스가 행동으로 분출되기 때문이래요. 하지만 원래는 유순한 성격을 가진 견종이기 때문에 활발한 활동량을 잘 맞춰준다면 아이들과 함께 키우기 좋은 특징을 가졌답니다!",
    imageUrl: "코카스파니엘.jpg",
  },
  {
    name: "슈나우저",
    englishName: "Schnauzer",
    description:
      "뚱한 표정을 가진 당신은 슈나우저를 닮았군요! 독일어로 수염이라는 뜻을 가진 슈나우저는 입 주변의 풍성한 털을 가진 것이 특징인데요! 처음엔 경계심이 강하지만 한 번 마음을 열면 살가운 성격으로 다가가는 매력을 가졌답니다! 호기심이 풍부하여 무언가를 계속 물어 뜯고 있는 모습을 볼 수 있어요!",
    imageUrl: "슈나우저.jpg",
  },
  {
    name: "불독",
    englishName: "Bulldog",
    description:
      "짧은 입과 살짝 나온 턱을 가진 당신은 불독을 닮았군요! 불독은 소를 컨트롤 하기 위해 개량된 견종으로, 과거에는 사슬에 매달아 놓을 정도로 표독한 성격을 가졌었다고 하네요. 하지만 현재는 온순한 성격을 가지게 되었고 반려견으로써 듬직한 친구가 될 수 있어요.",
    imageUrl: "불독.jpg",
  },
  {
    name: "비글",
    englishName: "Beagle",
    description:
      "장난끼 많은 개구쟁이 비글을 닮았네요!  비글은 애착이 많은 활발하고 낙천적인 성격이랍니다. 같이 있는 것을 좋아하고, 혼자 남겨지면 외로움을 느껴 늑대처럼 울부짖게 돼요. 호기심도 많고 활동량도 많아 넓은 장소에서 맘껏 뛰놀게 해줘야합니다! 장난끼 많고 발랄한 비글을 닮은 당신은 비글미가 뿜뿜! ",
    imageUrl: "비글.jpg",
  },
  {
    name: "치와와",
    englishName: "Chihuahua",
    description:
      "크고 땡그란 눈을 가진 치와와를 닮았네요! 치와와는 가장 작은 견종입니다. 몸집은 조그마하지만 주인에게 충직하고 겁이 없어 낯선 사람을 만나면 물거나 달려들기도 하는데요. 작은 몸집을 보고 얕본다면 큰 코 다칠 수 있으니, 친해지기 위해서는 천천히 다가가요~",
    imageUrl: "치와와.jpg",
  },
  {
    name: "닥스훈트",
    englishName: "Dachshund",
    description:
      "팔 다리는 짧지만 허리만은 기다란 닥스훈트를 닮았군요! 기다란 허리 때문에 소시지 독이라는 별명도 있어요. 닥스훈트는 성격이 밝고 명랑하며 쉽게 지치지 않아서 많은 시간을 들여 놀아주어야합니다. 애교가 많고 애기 같아서 항상 주인 옆에 딱 붙어있는 귀여운 소시지 독!",
    imageUrl: "닥스훈트.jpg",
  },
  {
    name: "페키니즈",
    englishName: "Pekingese",
    description:
      "도도한 페키니즈를 닮았네요! 과거에 페키니즈는 궁정 안에서 신성한 개로 키워져서 평민들은 페키니즈를 보면 절을 했어요. 도도했던 과거의 이력 때문인지 성격도 개보다는 고양이에 가까워요. 안기는 것을 그다지 좋아하지 않고 귀찮게 구는 것을 매우 싫어하는 독립적인 성격입니다. 하지만 페키니즈만의 냥아지 매력에 한번 빠지게 되면 헤어나오지 못하게 돼요.",
    imageUrl: "페키니즈.jpg",
  },
  {
    name: "핏불",
    englishName: "Pitbull",
    description:
      "카리스마가 넘치는 눈빛을 가진 핏불을 닮았네요. 평소엔 조용하고 차분한 성격이지만 한번 물면 절 때 놓치지 않을 만큼 목표물에 집착이 강합니다. 개들 중에서 사람을 가장 많이 죽이는 개로 알려져 있어요. 핏불의 신경을 건드리지 않도록 항상 조심 또 조심 🤐",
    imageUrl: "핏불.jpg",
  },
  {
    name: "사모예드",
    englishName: "Samoyed",
    description:
      "이름을 들으면 “사모님~”하고 부르고 싶은 사모예드를 닮았어요! 사모예드는 견종사이에서 가장 비싼 견종으로 알려져 있어요. 덩치는 크지만 순하고 친근합니다. 공격적인 면이 없고 사교성이 뛰어난 순둥이 중에 순둥이입니다. 입꼬리마저 살짝 올라가 있어 항상 웃고 있는 표정을 하고 있는 사모예드! 폭신한 털은 와락 끌어 앉고 싶은 욕구를 불러일으키네요~",
    imageUrl: "사모예드.jpg",
  },
  {
    name: "아프간하운드",
    englishName: "Afghan Hound",
    description:
      "고급진 헤어스타일을 자랑하는 아프간 하운드를 닮았네요. 예전엔 아프가니스탄에서 수렵용으로 길러졌지만 비단결 같은 머리와 아름다운 외모 덕으로 애완용으로 개량되어 온순해졌다고 합니다. 그런데 귀티나는 외모와는 달리 의외로 머리는 나쁘다고 알려져 있어요. 견종 IQ 테스트에서 하위 중에서도 최하위에 속한다고 합니다.",
    imageUrl: "아프간하운드.jpg",
  },
  {
    name: "바셋하운드",
    englishName: "Basset Hound",
    description:
      "축 쳐진 눈와 귀를 가진 바셋하운드를 닮았네요. 축 쳐진 눈 속 숨겨진 슬픈 눈망울은 바셋하운드만의 매력이에요. 바셋 하운드는 친절하고 태평스로운 견종이에요. 무리지어 생활하는 것에 익숙해 주변에 가족들이 함께 있을 때 가장 행복해합니다.",
    imageUrl: "바셋하운드.jpg",
  },
  {
    name: "올드잉글리쉬쉽도그",
    englishName: "Old English SheepDog",
    description:
      "앞이 보이긴 하나? 의문점이 들 정도로 수북한 앞머리를 가진 올드 잉글리쉬 쉽도그를 닮았네요. 무성한 털 때문에 인지하지 못하지만 의외로 좋은 비율의 몸매를 가지고 있어요. 올드 잉글리쉬 쉽도그는 영리하고 독립적인 성격을 가지고 있고 유머감각도 뛰어나다고 하네요!",
    imageUrl: "올드잉글리쉬쉽도그.jpg",
  },
  {
    name: "그레이하운드",
    englishName: "Greyhound",
    description:
      "따라올 테면 따라와봐. 가장 빠른 개로 알려진 그레이하운드를 닮았네요. 그런데 의외로 명성과는 다르게 게으르고 늘어져 있는 것을 좋아한다고 해요. 운동신경이 좋음에도 불구하고 낮잠 자는 것을 좋아한답니다. 얌전하고 조용한 성격을 가져서 공격성이 거의 없어 어린 아이들과도 잘 어울려 지내는 모습을 볼 수 있어요.  ",
    imageUrl: "그레이하운드.jpg",
  },
  {
    name: "진돗개",
    englishName: "Jindo Dog",
    description:
      "우리 것이 제일 좋은 것이여~! 국산 품종 진돗개를 닮았군요! 외모만 잘생긴 게 아니라 용맹하고 충성심이 강해요. 또 깔끔한 성격으로 자기 몸을 스스로 그루밍하며 평소 청결한 모습을 보여줍니다. 외모와 성격 모두 다 가진 진돗개를 닮은 당신 덕에 국산뽕에 취하네요 크흐~~. 진돗개는 천연기념물 제 53호인데요. 그 말은 즉, 진돗개를 닮은 당신의 외모도 천연기념물~?😉",
    imageUrl: "진돗개.jpg",
  },
  {
    name: "골든리트리버",
    englishName: "Golden Retriever",
    description:
      "귀티가 흐르는 금빛의 풍성한 털을 가진 골든리트리버를 닮은 당신! 온순한 성격 덕에 “천사견”이라고도 불리는데요. 그렇다면 당신도 천사?! 하늘에서 내려오다가 날개를 잃어버린 건가요!? 🥱 온순한 성격뿐만 아니라 누구와도 쉽게 친해지는 사교성과 똑똑한 견종 탑 5 안에 들어갈 만큼 스마트함을 가지고 있어요. 이 모든 장점을 다 가진 당신은 욕심쟁이 우후훗?!",
    imageUrl: "골든리트리버.jpg",
  },
  {
    name: "그레이트데인",
    englishName: "Great Dane",
    description:
      "기네스북 중 세계에서 가장 큰 개 4관왕을 차지하고 있는 그레이트데인을 닮은 당신! 애니메이션 “스쿠비두”에서 주인공 개 스쿠비두가 바로 그레이트데인입니다. 다부진 근육질 몸매와 늘씬한 라인을 가지고 있어 밸런스가 잘 갖춰진 몸을 가지고 있어요. 초대형견 답게 작은 일엔 신경을 쓰지 않는 귀공자 스타일인데요. 큰 덩치에 비해 공격성이 없고 온화한 성격이에요. 몸매도 성격도 모두 GREAT!",
    imageUrl: "그레이트데인.jpg",
  },
  {
    name: "도베르만",
    englishName: "Dobermann Pinscher",
    description:
      "포스 넘치는 외모의 주인공 도베르만을 닮았네요. 잘 발달된 근육질 몸매와 높은 지능 덕에 군견, 경찰견, 탐색견, 구조견 등 다양한 분야에서 직업견으로 활동하고 있어요. 취업 걱정은 할 필요가 없겠네요, 하하하 😅. 사람을 좋아하는 정이 많은 성격이고, 한 주인만을 섬기는 충직함으로 유명합니다.",
    imageUrl: "도베르만.jpg",
  },
  {
    name: "시베리안허스키",
    englishName: "Siberian Husky",
    description:
      "바라보고 있으면 빠져들 수밖에 없는 매력적인 파란 눈동자를 가진 시베리안허스키를 닮았네요. 파란 눈동자가 매서운 눈빛처럼 보일 수도 있지만 친근하고 유순한 성격이에요. 호기심도 많고 고집이 강해서 한번 하고 싶은 것은 반드시 하려고 하는 습성이 있어요. 혹시, 시베리안허스키를 닮은 당신의 목소리는 허스키 보이스?🤣 ",
    imageUrl: "시베리안허스키.jpg",
  },
  {
    name: "시바견",
    englishName: "Shiba Inu",
    description:
      "가즈아~!!! 도지코인의 주인공 시바견을 닮았군요! 도지코인 떄문에 금전적으로 많이 낭패(?)를 보셨다면 시바견의 이름을 자주 부르셨겠네요. 귀여운 외모와는 다르게 독립성이 강하고 애교가 없는 고집불통이에요. 츤데레 성격 때문에 다른 강아지들처럼 애정표현을 기대할 순 없지만 그 모습마져도 매력으로 느껴지는 우리의 시바~",
    imageUrl: "시바견.jpg",
  },
  {
    name: "시고르자브종",
    englishName: "Shigor Japjong",
    description:
      "똥개…아…아니, 시고르자브종을 닮은 당신! 하하;; 시골 할머니 댁에 가면 반갑다고 달려오는 친밀감 200%인 시고르자브종. 혈통을 알 수 없어서 “백구,” “황구,” “누렁이,” “점박이,” 등 다양한 이름으로 불려요. 강한 유전자 덕분에 웬만한 다른 개들보다 건강하지만 종잡을 수 없는 유전자로 다 컸을 때의 생김새를 예측하기 어려운 매력(?)도 가지고 있어요.",
    imageUrl: "시고르자브종.jpg",
  },
];

let dogDictionary = {};

for (let i = 0; i < dogDB.length; i++) {
  dogDictionary[dogDB[i].name] = {
    imageUrl: dogDB[i].imageUrl,
    description: dogDB[i].description,
  };
}

export default dogDictionary;
